import React from "react";
import "./DownloadBtn.scss";

interface DownloadBtnProps {
    href: string;
    filename?: string;
}

const getNameFromHref = (href: string): string => {
    try {
        const url = new URL(href, window.location.href);
        const pathname = url.pathname || href;
        const last = pathname.split("/").filter(Boolean).pop();
        return last || "file";
    } catch {
        const last = href.split("/").filter(Boolean).pop();
        return last || "file";
    }
};

const buildDownloadName = (href: string, filename?: string): string => {
    const fallback = getNameFromHref(href);

    if (!filename) {
        return fallback;
    }

    const hasExt = /\.[a-z0-9]+$/i.test(filename);
    if (hasExt) {
        return filename;
    }

    const match = fallback.match(/\.([a-z0-9]+)(?:$|\?)/i);
    if (!match) {
        return filename;
    }

    const ext = match[1];

    return `${filename}.${ext}`;
};

export const DownloadBtn: React.FC<DownloadBtnProps> = ({ href, filename }) => {
    const download = () => {
        if (!href) {
            return;
        }

        const finalName = buildDownloadName(href, filename);
        const link = document.createElement("a");
        link.href = href;
        link.download = finalName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <button className="download-btn" onClick={download}>
            <span className="download-btn-text">Download</span>
        </button>
    );
};